import { z } from "zod";

/**
 * A link a notification carries: http(s) only, at most 2048 characters, with no user or password
 * in it, because it becomes a Teams Action.OpenUrl and an email anchor. One schema for every link
 * the facts hold (`notifications.ts` `link`, `monitor.ts` `runLink`, #829).
 */
export const httpLinkSchema = z
  .url({ protocol: /^https?$/ })
  .max(2048)
  .refine((u) => {
    // zod 4 keeps refining after a failed url() check, so guard the parse: an unparseable
    // link is refused, never thrown (safeParse must answer success: false).
    if (!URL.canParse(u)) return false;
    const parsed = new URL(u);
    return parsed.username === "" && parsed.password === "";
  }, "A link carries no user name or password.");
